import axios from 'axios';
import { createAxiosConfig } from '../apiHelpers';
import LogCannon from '@ace-clublabs/log-cannon';
import { ChangeContactInfo } from '../contracts';
import { IChangeContactInfoRequest } from '@lib/types';
import { AxiosError } from 'axios';
import StatusCode from 'status-code-enum';

export const ChangeContactInfoApi =
  (endpoint: string): ChangeContactInfo =>
  async (request: IChangeContactInfoRequest) => {
    try {
      const response = await axios.post(endpoint, request, createAxiosConfig(endpoint));

      LogCannon.blast('ChangeContactInfo success');
      return Promise.resolve({
        status: 'success',
        data: response.data.data,
      });
    } catch (e: any | AxiosError) {
      const errorResponse = e?.response?.data?.error;
      LogCannon.blast('ChangeContactInfo error', errorResponse);
      return Promise.resolve({
        status: 'error',
        error: {
          code: e?.response?.status || StatusCode.ServerErrorInternal,
          message: 'Change contact info failed',
          ...errorResponse,
        },
      });
    }
  };
